export default __webpack_public_path__ + "static/media/app-preview.b4fb6ff2.svg";